import React, { useContext } from 'react'
import { InputText } from 'primereact/inputtext'
import { RadioButton } from 'primereact/radiobutton'
import { ReactComponent as EmailIcon } from './../../assets/svgs/elements-icon-email.svg'
import { injectIntl } from 'react-intl'
import './style.css'
import { User } from '../../models/user'
import { i18nContext } from '../../utils/localization/i18nWrapper'
import moment from 'moment'

type ProfileSidebarContentProps = {
    intl: any
    currentUser: User
    setLanguage: Function
}

const ProfileSidebarContent = (props: ProfileSidebarContentProps) => {
    const { intl } = props

    const { switchLanguage } = useContext(i18nContext)

    let languagesList = [
        {
            id: 'it-IT',
            label: 'profile_and_settings.languages.italian',
        },
        {
            id: 'en-EN',
            label: 'profile_and_settings.languages.english',
        },
        {
            id: 'es-ES',
            label: 'profile_and_settings.languages.spanish',
        },
        {
            id: 'fr-FR',
            label: 'profile_and_settings.languages.french',
        },
    ]

    return (
        <div className="profileSidebarContent">
            <div className="Name">{`${props.currentUser.given_name} ${props.currentUser.family_name}`}</div>
            <div className="Email">
                <div className="label">Email</div>
                <div className="p-inputgroup">
                    <span className="p-inputgroup-addon z-10">
                        <EmailIcon />
                    </span>
                    <InputText
                        placeholder="name.surname@topm.luxottica.com"
                        value={props.currentUser.mail}
                        className="z-5"
                        readOnly
                    />
                </div>
            </div>
            <div className="Languages">
                <div className="label">
                    {intl.formatMessage({
                        id: 'profile_and_settings.languages',
                    })}
                </div>
                <div>
                    {languagesList.map((language, i) => (
                        <div className="p-field-radiobutton" key={i}>
                            <RadioButton
                                inputId={'language' + language.id}
                                name="language"
                                value={language.id}
                                onChange={(e) => {
                                    localStorage.setItem(
                                        'LANGUAGE_just_changed',
                                        'true'
                                    )
                                    props.setLanguage(e.value)
                                    switchLanguage(language.id)
                                    moment.locale(language.id)
                                }}
                                checked={
                                    props.currentUser.curr_language ===
                                    language.id
                                }
                            />
                            <label htmlFor={'language' + language.id}>
                                {intl.formatMessage({
                                    id: language.label,
                                    defaultMessage: language.id,
                                })}
                            </label>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default injectIntl(ProfileSidebarContent)

